module.exports = __webpack_public_path__ + "static/media/Salvation - Church in Crisis.373f43ba.pdf";